import { IMG_URL } from "../../service/Api";

export const validateUrl = (url) => {
    if (!url) return IMG_URL + url;
    if (url.startsWith("https://")) {
      return url;
    }
    return IMG_URL + url;
  };